import { render } from "./Upload.vue?vue&type=template&id=21007355"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=21007355&lang=css"

import exportComponent from "/Volumes/programing/课题组工作/代码/annotation-tool-front/front-end/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__